import { createSelector } from "reselect";

import { IStore } from "@app/redux/reducers";

const getLoadingStateFunction = (store: IStore) => store.loading;
export const getLoadingState = createSelector(getLoadingStateFunction, f => f);
